import {createFileRoute} from '@tanstack/react-router';
import {InvoiceAccountClosePage} from 'features/one-time-credit/pages/InvoiceAccountClosePage/InvoiceAccountClosePage';

export const Route = createFileRoute(
  '/_protected/accounts/invoices/$accountId/close/confirm',
)({
  component: InvoiceAccountClosePage,
});
